export default "__VITE_ASSET__eed74f8c__"